// Load the large libs in one bundle
requirejs.config({
    name: 'lib-bundle',
    out: 'lib-bundle.min.js',
    paths: {

        'libphonenumber':'vendors/libphonenumber',
        Siema: 'vendors/siema',
        turf: 'vendors/turf-custom-build.min',//vendors/turf.min',
        taggle: 'vendors/taggle',
        'js-cookie': 'vendors/js-cookie',
        sha256: 'vendors/sha256',
        cleave: 'vendors/cleave',


    }, shim: {
        'jquery': {
            exports: '$'
        },
    }
});

require([
    'libphonenumber',
    'Siema',
    //'turf',
    'taggle',
    'js-cookie',
    'sha256',
    'cleave'
],function(){});
define("lib-bundle", function(){});

